import { ConditionalStyle } from '../../style_helpers'
import styles from '../styles'

export function getModalStyles (props) {
  return {
    ...styles.modal,
    ...ConditionalStyle(props.visible, styles.modalOpen)
  }
}

export function getContentStyles (props) {
  return {
    ...styles.content,
    ...ConditionalStyle(props.visible, styles.contentOpen)
  }
}
